import React, {Component} from 'react';

import san from '../../../../utils/sanitiser.js';

import Pending from '../../../pending.js';
import View from './view.js';

const NAME_INNER_CHAR_CLASS = "-a-zA-Z0-9,.!? '‘’";
const NAME_INPUT_FILTER = new RegExp(`[^${NAME_INNER_CHAR_CLASS}]`, 'g');

const COMMENT_INNER_CHAR_CLASS = "-a-zA-Z0-9,.!? '\"‘’“”\n";
const COMMENT_INPUT_FILTER = new RegExp(`[^${COMMENT_INNER_CHAR_CLASS}]`, 'g');

export default class Parent extends Component {

  constructor(props) {
    super(props);
    this.user = props.user;
    this.gatekeeper = props.gatekeeper;
    this.endpoints = props.endpoints;
    this.match = props.match;
    this.state = {
      order: null,
      fetchError: null,
      saveError: null,
      newReview: {
        rating: null,
        name: '',
        comment: '',
      },
      posted: false,
    };

    this.isAnonReview = /^O_/.exec(this.match.params.orderId) ? true : false;
    this.successfulPostRedirectUrl = this.isAnonReview ?
      this.endpoints.anonReviewSubmitted() :
      this.endpoints.reviewSubmitted();

    this.changeRating = this.changeRating.bind(this);
    this.changeName = this.changeName.bind(this);
    this.changeComment = this.changeComment.bind(this);
    this.dismissSaveError = this.dismissSaveError.bind(this);
    this.save = this.save.bind(this);

    this.renderPending = this.renderPending.bind(this);
    this.renderFetchError = this.renderFetchError.bind(this);
    this.renderExistingReview = this.renderExistingReview.bind(this);
    this.renderNewReview = this.renderNewReview.bind(this);
  }

  async componentDidMount() {
    try {
      const data = await this.gatekeeper.getData();
      this.setState({
        ...this.state,
        order: data.order,
        newReview: { ...this.state.newReview, name: data.order.suggested_name },
      });
    } catch (err) {
      if (!this.props.suppressConsoleErrors) {
        console.error('Error: ', err);
      }
      this.setState({ ...this.state, fetchError: err });
    }
  }

  changeRating(r) {
    this.setState({ ...this.state, newReview: { ...this.state.newReview, rating: r } });
  }

  changeName(n) {
    const val = n.replace(NAME_INPUT_FILTER, '');
    this.setState({ ...this.state, newReview: { ...this.state.newReview, name: val } });
  }

  changeComment(c) {
    const val = c.replace(COMMENT_INPUT_FILTER, '');
    this.setState({ ...this.state, newReview: { ...this.state.newReview, comment: val } });
  }

  dismissSaveError() {
    this.setState({ ...this.state, saveError: null });
  }

  async save() {
    try {
      const nr = { ...this.state.newReview };
      nr.name = san(nr.name);
      nr.comment = san(nr.comment);
      const data = await this.gatekeeper.saveData({ review: nr });
      this.setState({
        ...this.state,
        order: data.order,
        posted: true,
      });
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, saveError: err });
    }
  }

  renderPending() {
    return (<Pending/>);
  }

  renderFetchError() {
    return(
      <section className="FetchError api-error">
        <h2>Failed to retrieve the order to review</h2>
        <p>Please contact support if this problem persists.</p>
      </section>
    );
  }

  renderSaveError() {
    return(
      <div>
        <section className="SaveError api-error">
          <h2>We're sorry, your review failed to save</h2>
          <p>
            Please <a href={this.endpoints.support()}
                      target="_blank"
            >contact support</a> if this problem persists.
          </p>
          <p>
            <button onClick={this.dismissSaveError}>Dismiss this message</button>
          </p>
        </section>
        {this.renderNewReview()}
      </div>
    );
  }

  renderExistingReview() {
    this.handlePosted();
  }

  renderNewReview() {
    return (
      <View
        user={this.user}
        order={this.state.order}
        newReview={this.state.newReview}
        changeRating={this.changeRating}
        changeName={this.changeName}
        changeComment={this.changeComment}
        save={this.save}
      />
    );
  }

  handlePosted() {
    window.location = this.successfulPostRedirectUrl;
  }

  render() {
    if (this.state.posted) {
      this.handlePosted();
      return null;
    } else if (this.state.fetchError) {
      return this.renderFetchError();
    } else if (this.state.saveError) {
      return this.renderSaveError();
    } else if (this.state.order) {
      if (this.state.order.review) {
        this.renderExistingReview();
        return null;
      } else {
        return this.renderNewReview();
      }
    } else {
      return this.renderPending();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reviews/new/review/parent.js